// Central registry of every service detail page.
// Used for related-services links + the header dropdown.
export const SERVICES_INDEX = [
  {
    slug: 'apostille',
    name: 'Apostille & International Certification',
    short: 'Apostille',
    blurb:
      'Expedited Tennessee SOS apostille for births, marriages, diplomas, FBI checks, and corporate filings.',
  },
  {
    slug: 'estate-planning',
    name: 'Estate Planning Documents',
    short: 'Estate Planning',
    blurb:
      'Trust packages, healthcare directives, POAs — bedside or office, handled with discretion.',
  },
  {
    slug: 'remote-online-notarization',
    name: 'Remote Online Notarization',
    short: 'Remote Online Notarization',
    blurb:
      'Tennessee-compliant audio-visual notarization from anywhere in the world.',
  },
  {
    slug: 'loan-signing',
    name: 'Loan Document Signing',
    short: 'Loan Signing',
    blurb:
      'Certified Notary Signing Agent for refinances, purchases, HELOCs, and reverse mortgages.',
  },
  {
    slug: 'general-notary',
    name: 'General Mobile Notary',
    short: 'General Notary',
    blurb:
      'Affidavits, sworn statements, vehicle titles, parental consent — anywhere in Nashville.',
  },
  {
    slug: 'wedding-officiant',
    name: 'Wedding Officiant',
    short: 'Wedding Officiant',
    blurb:
      'Personalized ceremonies for elopements, courthouse, micro-weddings, and vow renewals.',
  },
  {
    slug: 'fingerprinting',
    name: 'Ink Fingerprinting',
    short: 'Ink Fingerprinting',
    blurb:
      'Traditional ink fingerprint cards for licensing, adoption, immigration, and concealed-carry — no electronic / digital live-scan.',
  },
  {
    slug: 'i9-verification',
    name: 'I-9 Employment Verification',
    short: 'I-9 Verification',
    blurb:
      'USCIS-compliant on-site I-9 verification for Nashville employers and remote hires.',
  },
  {
    slug: 'process-serving',
    name: 'Process Serving',
    short: 'Process Serving',
    blurb:
      'Reliable legal-document delivery with court-ready proof of service — statewide Tennessee.',
  },
  {
    slug: 'document-translation',
    name: 'Document Translation',
    short: 'Document Translation',
    blurb:
      'Certified translation of foreign-language documents — birth certificates, diplomas, marriage records — paired with notarization and apostille when needed.',
  },
];

// Service-specific hero imagery (Unsplash, royalty-free).
export const SERVICE_HERO_IMAGES = {
  apostille:
    'https://images.unsplash.com/photo-1568992687947-868a62a9f521?w=1920&q=80&auto=format&fit=crop',
  'estate-planning':
    'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=1920&q=80&auto=format&fit=crop',
  'remote-online-notarization':
    'https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?w=1920&q=80&auto=format&fit=crop',
  'loan-signing':
    'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1920&q=80&auto=format&fit=crop',
  'general-notary':
    'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=1920&q=80&auto=format&fit=crop',
  fingerprinting:
    'https://images.unsplash.com/photo-1614064642639-e398cf05badb?w=1920&q=80&auto=format&fit=crop',
  'i9-verification':
    'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=1920&q=80&auto=format&fit=crop',
  'process-serving':
    'https://images.unsplash.com/photo-1589216532372-1c2a367900d9?w=1920&q=80&auto=format&fit=crop',
  'document-translation':
    'https://images.unsplash.com/photo-1457369804613-52c61a468e7d?w=1920&q=80&auto=format&fit=crop',
};
